import type { ReactElement } from 'react'
import { PaperGrad, BeadyEye, STROKE, SHADOW, type GlyphProps } from './shared'

/* BEETLE / KABUTO — helmet body with twin horns */
export const Beetle = ({ size = 110 }: GlyphProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 120 120" style={SHADOW}>
    <defs>
      <PaperGrad id="beetle-l" light="#e6dcf2" dark="#c2afe0"/>
      <PaperGrad id="beetle-d" light="#c2afe0" dark="#8a6fc4"/>
    </defs>
    {/* main helmet body */}
    <polygon points="60,28 96,60 86,94 34,94 24,60" fill="url(#beetle-l)" stroke={STROKE} strokeWidth="2.2" strokeLinejoin="round"/>
    {/* outer horns (kuwagata) */}
    <polygon points="60,28 8,12 36,52" fill="url(#beetle-d)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <polygon points="60,28 112,12 84,52" fill="url(#beetle-d)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    {/* inner horn fold */}
    <polygon points="60,28 26,22 46,48" fill="url(#beetle-l)" stroke={STROKE} strokeWidth="1.2" strokeLinejoin="round"/>
    <polygon points="60,28 94,22 74,48" fill="url(#beetle-l)" stroke={STROKE} strokeWidth="1.2" strokeLinejoin="round"/>
    {/* shaded center triangle */}
    <polygon points="60,28 78,72 60,84 42,72" fill="url(#beetle-d)" opacity="0.6" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 2" strokeLinejoin="round"/>
    <line x1="60" y1="28" x2="60" y2="94" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 2"/>
    <BeadyEye cx={48} cy={68} r={2}/>
    <BeadyEye cx={72} cy={68} r={2}/>
  </svg>
)
